export class PrismHRAPIPermissionsRequest{
    public apiUrl!:string;
    public username!:string;
    public password!:string; 
    public peoId!:string;
}